import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="csv" transform="translate(-565 -298)">
        <g id="file-extension" transform="translate(565 298)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#d05164"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#9a1d2f"
          />
          <path
            id="Контур_818"
            data-name="Контур 818"
            d="M3.459-1.7A1.421,1.421,0,0,1,3.24-.98,1.322,1.322,0,0,1,2.678-.5a1.914,1.914,0,0,1-.827.171,1.528,1.528,0,0,1-1.208-.5A2.063,2.063,0,0,1,.2-2.238V-2.43a2.355,2.355,0,0,1,.2-1,1.508,1.508,0,0,1,.573-.663,1.6,1.6,0,0,1,.866-.234,1.677,1.677,0,0,1,1.138.373,1.473,1.473,0,0,1,.489,1.027H2.532a.7.7,0,0,0-.179-.51.736.736,0,0,0-.513-.155.56.56,0,0,0-.513.262,1.683,1.683,0,0,0-.171.836v.275a1.862,1.862,0,0,0,.156.89.572.572,0,0,0,.538.267.72.72,0,0,0,.494-.152A.646.646,0,0,0,2.527-1.7Zm2.5.283a.385.385,0,0,0-.146-.321,1.81,1.81,0,0,0-.512-.238,4.909,4.909,0,0,1-.6-.238,1.133,1.133,0,0,1-.756-1.021.915.915,0,0,1,.188-.57,1.218,1.218,0,0,1,.533-.385,2.074,2.074,0,0,1,.775-.138,1.815,1.815,0,0,1,.752.15,1.191,1.191,0,0,1,.517.426,1.113,1.113,0,0,1,.184.632H5.967a.47.47,0,0,0-.146-.369.568.568,0,0,0-.394-.131.64.64,0,0,0-.4.111.34.34,0,0,0-.146.282.343.343,0,0,0,.16.271,2.022,2.022,0,0,0,.564.251,3.454,3.454,0,0,1,.663.279,1.114,1.114,0,0,1,.631,1,.95.95,0,0,1-.385.8,1.711,1.711,0,0,1-1.055.291A2.094,2.094,0,0,1,4.606-.5a1.291,1.291,0,0,1-.577-.465,1.211,1.211,0,0,1-.194-.68h.941a.6.6,0,0,0,.162.461.764.764,0,0,0,.525.148.6.6,0,0,0,.367-.1A.331.331,0,0,0,5.964-1.415Zm2.983-.024.775-2.832H10.77L9.461-.381H8.435l-1.3-3.89H8.175Z"
            transform="translate(4.625 15)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
